export default class Image {
    constructor(
        public id: string = '',
        public path: string = '',
        public isFavorite: boolean = false,
    ) {}

    public static fromJson(json: any): Image {
        return new Image(
            json.id,
            json.path,
            json.isFavorite
        );
    }
}